import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import BannerImage from "../../assets/fastvisa-icon.png";
import "./PreLoginFooter.css";

const SOCIAL = {
  facebook: "https://www.facebook.com/fastvisa.latam",
  instagram: "https://www.instagram.com/fastvisa.latam",
  tiktok: "https://www.tiktok.com/@fastvisa.latam",
};
const EMAIL = "info.fastvisa@orionscaled.com";

const PreLoginFooter = () => {
  const { t } = useTranslation();

  return (
    <footer className="prelogin-footer">
      <div className="prelogin-footer__sheet">
        <div className="prelogin-footer__logo-wrap">
          <Link to="/" className="prelogin-footer__logo">
            <img
              src={BannerImage}
              alt="FastVisa"
              className="prelogin-footer__logo-img"
            />
          </Link>
        </div>
        <div className="prelogin-footer__social">
          <p className="prelogin-footer__social-title">
            {t("siguenosRedes", "Síguenos en nuestras redes sociales")}
          </p>
          <div className="prelogin-footer__social-icons">
            <a
              href={SOCIAL.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="prelogin-footer__social-link"
              title="Facebook"
              aria-label="Facebook"
            >
              <svg
                viewBox="0 0 24 24"
                className="prelogin-footer__icon"
                aria-hidden="true"
              >
                <path
                  fill="currentColor"
                  d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                />
              </svg>
            </a>
            <a
              href={SOCIAL.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="prelogin-footer__social-link"
              title="Instagram"
              aria-label="Instagram"
            >
              <svg
                viewBox="0 0 24 24"
                className="prelogin-footer__icon"
                aria-hidden="true"
              >
                <path
                  fill="currentColor"
                  d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.766 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"
                />
              </svg>
            </a>
            <a
              href={SOCIAL.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              className="prelogin-footer__social-link"
              title="TikTok"
              aria-label="TikTok"
            >
              <svg
                viewBox="0 0 24 24"
                className="prelogin-footer__icon"
                aria-hidden="true"
              >
                <path
                  fill="currentColor"
                  d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"
                />
              </svg>
            </a>
          </div>
        </div>
        <div className="prelogin-footer__contact">
          <h4 className="prelogin-footer__contact-title">
            {t("contacto", "Contacto")}
          </h4>
          <a
            href={`mailto:${EMAIL}`}
            className="prelogin-footer__contact-email"
          >
            {EMAIL}
          </a>
        </div>
      </div>
      <div className="prelogin-footer__bottom">
        <p className="prelogin-footer__copyright">© 2026 Orion Scaled</p>
      </div>
    </footer>
  );
};

export default PreLoginFooter;
